<div class="content md3-surface">
  <div class="layout-list-quickfilter md3-card-on-surface">
    <!-- Search Header -->
    <exg-search-bar (Search)="taskTable.search($event)"
                    [placeholder]="getRessource('SearchHolder')"
                    class="span-layout">
      <ng-template #rightTemplate>
        <i (click)="taskTable.loadData()" class="search-action fal fa-sync"></i>
        <app-exg-dropdown>
          <ng-template #hostTemplate>
            <i class="search-action fa-filter"
               [class.fas]="taskTable.uiFilterAktiv(1).length > 0"
               [class.fal]="taskTable.uiFilterAktiv(1).length === 0"></i>
          </ng-template>
          <ng-template #contentTemplate let-popup>
            <app-exg-filter #VCtaskTableFilterControl
                            (onActivateFilter)="taskTable.pageChanged(1);popup.close()"
                            [MetaInfo]="taskTable.MetaInfo"
                            [visibility]="popup.visibility !== 'hidden'"
                            [showFilter]="true" [uiFilter]="taskTable.uiFilter"
                            [uiSort]="taskTable.uiSort"></app-exg-filter>
          </ng-template>
        </app-exg-dropdown>
        <app-exg-dropdown>
          <ng-template #hostTemplate>
            <i class="search-action fa-sort-alt"
               [class.fas]="taskTable.uiSortAktiv().length > 0"
               [class.fal]="taskTable.uiSortAktiv().length === 0"></i>
          </ng-template>
          <ng-template #contentTemplate let-popup>
            <app-exg-filter #VCtaskTableSortControl
                            (onActivateFilter)="taskTable.pageChanged(1);popup.close()"
                            [MetaInfo]="taskTable.MetaInfo"
                            [visibility]="popup.visibility !== 'hidden'"
                            [showSort]="true" [uiFilter]="taskTable.uiFilter"
                            [uiSort]="taskTable.uiSort"></app-exg-filter>
          </ng-template>
        </app-exg-dropdown>
        <app-exg-dropdown>
          <ng-template #hostTemplate>
            <i class="search-action fa-binoculars"
               [class.fas]="taskTable.uiFilterAktiv(2).length > 0"
               [class.fal]="taskTable.uiFilterAktiv(2).length === 0"></i>
          </ng-template>
          <ng-template #contentTemplate let-popup>
            <app-exg-filter (onActivateFilter)="taskTable.pageChanged(1);popup.close()"
                            [MetaInfo]="taskTable.MetaInfo" #VCtaskTableSearchControl
                            [showSearch]="true" [uiFilter]="taskTable.uiFilter"
                            [visibility]="popup.visibility !== 'hidden'"
                            [uiSort]="taskTable.uiSort"></app-exg-filter>
          </ng-template>
        </app-exg-dropdown>
	      <i class="search-action fal fa-gears"
           [class.disabled]="!taskTable.newV2Table"
           (click)="openTableSettings($event)">
        </i>
        <exg-table-settings #tableDefinitionSettings
                            [tableDef]="taskTable.tableDefinition"
                            [metaInfo]="taskTable.MetaInfo"
                            localStorageID="taskTable">
        </exg-table-settings>
        <i class="search-action fa-table"
           (click)="taskTable.newV2Table = !taskTable.newV2Table; chDecRefWakeUp();"
           [class.fas]="taskTable.newV2Table"
           [class.fal]="!taskTable.newV2Table">
        </i>
      </ng-template>
    </exg-search-bar>
    <div class="content">
      <div class="drawer-container left app-table-drawer"></div>
	    <ng-container *ngIf="!taskTable.newV2Table">
        <exg-data-table #VCtaskTable
                        [selectSource]="taskTable.selectedRow"
                        (RowChange)="taskTable.selectionChanged($event)"
                        (RowDblClick)="openWorkspaceV2($event)"
                        (ItemSelect)="taskTable.selectedRow"
                        [allowSingleSelection]="true"
                        [displayState]="taskTable.state"
                        [rowSource]="taskTable.data"
                        containerClass="grid cols-24"
                        [selectKey]="taskTable.selectKey">
          <ng-template #headerTemplate>
            <div class="span-2">
              <p><strong>{{enumSvc.getFieldCaption('Vorgang', 'vorgNr')}}</strong></p>
              <p><strong>{{enumSvc.getFieldCaption('AuftragE_EIS', 'aueSchadenNr')}}</strong></p>
            </div>
            <div [class.span-2]="userType === 1"
                 [class.span-3]="userType === 2">
              <p><strong>{{enumSvc.getFieldCaption('Auftrag', 'aueVersicherungsnehmer')}}</strong></p>
              <p>
                <strong>{{enumSvc.getFieldCaption('AuftragE_EIS', 'aueSchadenOrt')}}</strong>
              </p>
            </div>
            <div [class.span-2]="userType === 1"
                 [class.span-3]="userType === 2">
              <p><strong>{{enumSvc.getFieldCaption('Auftrag', 'au_oeID_Auftraggeber')}}</strong></p>
              <p><strong>{{enumSvc.getFieldCaption('AuftragE_EIS', 'aue_enmIdent_SchadenArt')}} ({{enumSvc.getFieldCaption('AuftragE_EIS', 'aue_enmIdent_Versicherungsart')}})</strong></p>
            </div>
            <div class="span-3">
              <p><strong>{{enumSvc.getFieldCaption('Vorgang', 'vorg_enmIdent_VorgangTyp')}}</strong></p>
            </div>
            <div class="span-3">
              <p><strong>{{getRessource('TableRenames.Bearbeiter')}} ({{getRessource('TableRenames.lastSV')}})</strong></p>
              <p><strong>{{getRessource('TableRenames.lastSP')}}</strong></p>
            </div>
            <div class="span-2">
              <p><strong>{{getRessource('TableRenames.OrtsterminIst')}}</strong></p>
              <p><strong>{{getRessource('TableRenames.OrtsterminPlan')}}</strong></p>
            </div>
	          <div class="span-2">
		          <p><strong>{{enumSvc.getFieldCaption('AuftragE_EIS', 'aueOrtstermin2')}}</strong></p>
		          <p><strong>{{enumSvc.getFieldCaption('AuftragE_EIS', 'aueKontaktaufnahmeVersuche')}}</strong></p>
	          </div>
            <div class="span-2" *ngIf="userType === 1">
              <p><strong>{{enumSvc.getFieldCaption('All', '%CKU')}}</strong></p>
              <p><strong>{{enumSvc.getFieldCaption('All', '%CKD')}}</strong></p>
            </div>
            <div class="span-2">
              <p><strong>{{enumSvc.getFieldCaption("All", "%LCU")}}</strong></p>
              <p><strong>{{enumSvc.getFieldCaption("All", "%LCD")}}</strong></p>
            </div>
            <div class="span-2">
              <p><strong>
                {{enumSvc.getFieldCaption('Vorgang', 'vorgFristDiff')}}
              </strong></p>
              <p><strong>
                ({{enumSvc.getFieldCaption('Vorgang', 'vorgFrist')}})
              </strong></p>
            </div>
            <div class="span-2">
              <p><strong>{{getRessource('TableRenames.AbrechnungsHinweis')}}</strong></p>
              <p><strong>{{enumSvc.getFieldCaption('Vorgang', 'vorgVorgangStatus')}}</strong></p>
            </div>
          </ng-template>
          <ng-template #rowTemplate let-row >
            <div class="span-2">
              <p>{{row.vorgNr}}</p>
              <p>{{row.aueSchadenNr}}</p>
            </div>
            <div [class.span-2]="userType === 1"
                 [class.span-3]="userType === 2">
              <p>{{row.aueVersicherungsnehmer}}</p>
              <p>{{row.aueSchadenOrt || '-'}}</p>
            </div>
            <div [class.span-2]="userType === 1"
                 [class.span-3]="userType === 2">
              <p>{{row.auAuftraggeberShort}}</p>
              <p>{{enumSvc.getEnumerationText('Schadenart', row.aue_enmIdent_SchadenArt)}}
                ({{enumSvc.getEnumerationText('Versicherungsart', row.aue_enmIdent_Versicherungsart)}})</p>
            </div>
            <div class="span-3">
              <p>{{enumSvc.getEnumerationText('VorgangTyp', row.vorg_enmIdent_VorgangTyp)}}</p>
            </div>
            <div class="span-3">
              <p>
                {{row.vorgBearbeiter  || '-'}}{{row.vorgBearbeiter === row.aueLetzterSachverstaendiger && !!row.aueLetzterSachverstaendiger ?
                '* (Beides)' : ' '
                }}{{row.aueLetzterSachverstaendiger && row.vorgBearbeiter !== row.aueLetzterSachverstaendiger ?
                '(' + row.aueLetzterSachverstaendiger + ')' : ''}}
              </p>
              <p>
                {{row.aueLetzterSanierungspartner ? row.aueLetzterSanierungspartner : '-'}}
              </p>
            </div>
            <div class="span-2">
              <p>
                {{(row.aueOrtstermin && row.aueOrtstermin > 0 ? row.aueOrtstermin : undefined) | excDate: getGlobal('DateFormat')}}
                {{!row.aueOrtstermin || row.aueOrtstermin === 0  ? '-' : '' }}
              </p>
              <p>
                {{(row.aueOrtsterminPlan && row.aueOrtsterminPlan > 0 ? row.aueOrtsterminPlan : undefined) | excDate: getGlobal('DateTimeFormatShort')}}
                {{!row.aueOrtsterminPlan || row.aueOrtsterminPlan === 0  ? '-' : '' }}
              </p>
            </div>
	          <div class="span-2">
		          <p>
			          {{(row.aueOrtstermin2 && row.aueOrtstermin2 > 0 ? row.aueOrtstermin2 : undefined) | excDate: getGlobal('DateFormat')}}
			          {{!row.aueOrtstermin2 || row.aueOrtstermin2 === 0 ? '-' : '' }}
		          </p>
		          <p>
			          {{(row.contactAttempt && row.contactAttempt > 0 ? row.contactAttempt : undefined) | excDate: getGlobal('DateTimeFormatShort')}}
			          {{!row.contactAttempt || row.contactAttempt === 0  ? '-' : '' }}
		          </p>
	          </div>
            <div class="span-2 " *ngIf="userType === 1">
              <p>{{row.vorgCKU || '-'}}</p>
              <p>{{row.vorgCKD | excDate: getGlobal('DateTimeFormatShort')}}</p>
            </div>
            <div class="span-2 ">
              <p>{{row.vorgLCU || '-'}}</p>
              <p>{{row.vorgLCD | excDate: getGlobal('DateTimeFormatShort')}}</p>
            </div>
            <div class="span-2">
              <p *ngIf="row.vorgFristDifference">
                {{row.vorgFristDifference}}
              </p>
              <p *ngIf="row.vorgFrist">
                ({{row.vorgFrist | excDate: getGlobal('DateFormat')}})
              </p>
            </div>
            <div class="span-2 ">
              <p *ngIf="row.aueAbrechnungshinweis_enmIdent">
                {{enumSvc.getEnumerationText('Abrechnungshinweis', row.aueAbrechnungshinweis_enmIdent)}}
              </p>
              <p *ngIf="!row.aueAbrechnungshinweis_enmIdent">
                -
              </p>
              <p>{{enumSvc.getEnumerationText('VorgangStatus', row.vorg_enmIdent_VorgangStatus)}}</p>
            </div>
          </ng-template>
        </exg-data-table>
      </ng-container>
      <ng-container *ngIf="taskTable.newV2Table">
        <exg-table #VCtaskTableV2
                   (RowDblClick)="openWorkspaceV2($event)"
                   (RowChange)="taskTable.selectionChanged($event)"
                   (FilterActivation)="taskTable.loadData()"
                   [selectKey]="taskTable.selectKey"
                   [rowSource]="taskTable.data"
                   [tableDef]="taskTable.tableDefinition"
                   [distinctTableName]="'Vorgaenge'"
                   [metaInfo]="taskTable.MetaInfo"
                   [displayState]="taskTable.state"
                   class="content"
                   [allowMultiSelection]="false"
                   [allowSingleSelection]="true"
                   (loadDistinct)="taskTable.getDistinctData($event)"
                   [distinctData]="taskTable.distinctData">
        </exg-table>
      </ng-container>
      <div class="drawer-container right app-table-drawer">
        <div [ngClass]="{'visible': rightDrawerVisible }"
             class="drawer-content md3-card-on-surface app-space-right_0">
          <div class="content width-500 ">
            <app-exg-tab-v2 #VCrightTabControl (tabchange)="rightTabs_tabChange($event)"
                     [hidden]="appSvc.isTableEmpty(taskTable) || appSvc.isTableLoading(taskTable) || appSvc.isTableLoading(TaskSummary.taskDetails)"
                     [header]="rightTabs">
              <ng-template #pages>
	              <!-- 1 - Details-->
	              <div class="content">
		              <!-- 1 - Details-->
		              <app-drawer-task-details *ngIf="TaskSummary && !TaskSummary.isLoading"
		                                       [data]="TaskSummary.taskDetails?.data"
		                                       [oeList]="TaskSummary.oeList?.data"
		                                       [Schadenort]="TaskSummary.Schadenort?.data">
		              </app-drawer-task-details>
		              <div class="search-filter-seperator"></div>
		              <app-drawer-case-details *ngIf="TaskSummary && !TaskSummary.isLoading"
		                                       [data]="TaskSummary.caseDetails?.data"
		                                       [oeList]="TaskSummary.oeList?.data"
		                                       [Schadenort]="TaskSummary.Schadenort?.data">
		              </app-drawer-case-details>
	              </div>
	              <!--2 - Anhänge -->
	              <div class="content">
		              <app-tab-task-attachment
			              [entityID]="TaskSummary?.ID"
			              [SummaryAttachmentTable]="TaskSummary?.attachmentJagTable"
			              [ConfigAttachmentTable]="config.attachmentJagTable"
			              [Events]="Events"
                    [AttachmentFolderStates]="openAttachmentFolder"
                    (attachmentFolderStatesChange)="saveAttachmentFolderStates($event)"
                    [auftragData]="TaskSummary?.caseDetails?.data"
                    [taskList]="TaskSummary?.taskList.data">
		              </app-tab-task-attachment>
	              </div>
	              <!--3 - Report Tab -->
	              <div class="content">
		              <app-tab-report-details
			              *ngIf="!TaskSummary.isLoading"
			              [entityID]="TaskSummary?.ID"
			              [SummaryCalculationTable]="TaskSummary?.calculationVersion.data"
			              [SummaryQuestionnaireTable]="TaskSummary?.questionnaireVersion.data"
			              [SummaryPhotoDocumentationTable]="TaskSummary?.photoDocumentation.data"
                    [ReportFolderStates]="openReportFolder"
                    (reportFolderStatesChange)="saveReportFolderStates($event)"
			              [Events]="Events"
		              >
		              </app-tab-report-details>
	              </div>
	              <!--4 - Formular -->
	              <div class="content">
		              <app-tab-task-formular
			              *ngIf="!TaskSummary?.taskDetails?.isLoading"
			              [formularVersion]="TaskSummary?.formularVersion"
			              [Events]="Events">
		              </app-tab-task-formular>
	              </div>
	              <!--5 - Receipt -->
	              <div class="content">
		              <app-tab-task-receipt
			              *ngIf="!TaskSummary?.taskDetails?.isLoading"
			              [ConfigReceiptTable]="config.receiptList"
			              [SummaryReceiptTable]="TaskSummary?.receiptList"
			              [Events]="Events">
		              </app-tab-task-receipt>
	              </div>
	              <!--6 - Leistungsaufstellungen -->
	              <div class="content">
		              <app-tab-task-leistung
			              *ngIf="!TaskSummary?.taskDetails?.isLoading"
			              [ConfigLeistungTable]="config.leistungList"
			              [SummaryLeistungTable]="TaskSummary?.leistungList"
			              [Events]="Events">
		              </app-tab-task-leistung>
	              </div>
	              <!--7 - Fragen-->
	              <div class="content">
		              <div class="layout-1-auto">
			              <div class="content app-subarea">
				              <exg-data-list [allowSingleSelection]="false"
				                             [rowSource]="TaskSummary?.dialogueQuestions?.data"
				                             selectKey="dfID">
					              <ng-template #rowTemplate let-row>
						              <div class="list-row list-single-line-auto-1 typo-small">
							              <div><strong>{{row.dfText}}</strong></div>
							              <div class="list-secondary-text"
							                   *ngIf="row.deValue && row.deValue.length > 0">{{row.deValue}}</div>
							              <div class="list-secondary-text" style="font-style: italic"
							                   *ngIf="!row.deValue || row.deValue.length === 0">
								              &lt;&lt;{{getRessource('noneMessages.noAnswerer')}}&gt;&gt;
							              </div>
						              </div>
					              </ng-template>
				              </exg-data-list>
			              </div>
			              <div>
			              </div>
		              </div>
	              </div>
	              <!--8 - Verlauf -->
	              <div class="content">
		              <app-tab-task-flowtable
			              [ConfigFlowTable]="config.flowTable"
			              [SummaryFlowTable]="TaskSummary?.flowTable"
			              [Events]="Events">
		              </app-tab-task-flowtable>
	              </div>
	              <!--9 - Vorgänge-->
	              <div class="content">
		              <exg-data-list #VCVorganglist
		                             selectKey="vorgID"
		                             [displayState]="TaskSummary?.taskList?.data && TaskSummary?.taskList?.data.length > 0 ? 0 : 2"
		                             [rowSource]="TaskSummary?.taskList.data"
		                             [selectSourceRows]="config.taskList.selectedObjects"
		                             (RowChange)="config.taskList.rowChange($event)"
		                             (ItemSelect)="config.taskList.itemSelect($event)">
			              <ng-template #rowTemplate let-task>
				              <div class="list-row-auto-1"
				                   (dblclick)="onClickOpenTaskCheckview(task)"
				                   [class.active]="config.taskList.selectedObjects[0] === task">
					              <div></div>
					              <div class="layout-auto-1-auto-grid-1-auto grid typo-small">
						              <div class="list-metadata" style="margin-left:0">
							              <div>
								              {{enumSvc.getEnumerationText('VorgangStatus', task.vorg_enmIdent_VorgangStatus)}} -
								              {{enumSvc.getEnumerationText('VorgangTyp', task.vorg_enmIdent_VorgangTyp)}}
							              </div>
							              <div>Auftraggeber: {{task.auAuftraggeberShort}} Schadenart: {{enumSvc.getEnumerationText('Schadenart', task.aue_enmIdent_SchadenArt)}}</div>
						              </div>
						              <div class="list-metadata ">
							              <div
								              class="typo-right">{{task.vorgLCD | excDate: 'Globals.DateTimeFormatShort'}}
							              </div>
						              </div>
						              <div style="height: 30px">
                                <span class="typo-center">
                                  <span [tooltip]="'Nicht Geprüft'" flow="right">
                                    <i class="fa-solid fa-xmark c-red" style="font-size: 14px" *ngIf="!task.vorgCKD"></i>
                                  </span>
                                  <span [tooltip]="'Geprüft'" flow="right">
                                    <i class="fa-solid fa-check c-green" style="font-size: 14px" *ngIf="task.vorgCKD"></i>
                                  </span>
                                </span>
							              <span class="app-space-left">
                                  <strong>{{task.vorgNr}}</strong>
                                </span>
						              </div>
						              <div class="typo-right">
							              <i class="search-action fa-regular fa-chevron-right"
							                 *ngIf="config.taskList.selectedObjects[0] === task"
							                 (click)="onClickOpenTaskCheckview(task)">
							              </i>
						              </div>
						              <div class="span-2 typo-container-s-s-q app-space-left_none">
							              <ng-container *ngIf="task.vorgBeschreibung && task.vorgBeschreibung.length > 0">
                                  <span style="width: 148px">
                                    {{enumSvc.getFieldCaption('Vorgang', 'vorgBeschreibung')}}:
                                  </span>
								              <span class="typo-left"
								                    *ngIf="config.taskList.selectedObjects[0] === task">
                                    {{task.vorgBeschreibung}}
                                  </span>
								              <span class="typo-left"
								                    *ngIf="config.taskList.selectedObjects[0] !== task">
                                    {{task.vorgBeschreibung.slice(0, 48)}}
									              {{task.vorgBeschreibung.length > 48 ? '...' : ''}}
                                  </span>
								              <q></q>
							              </ng-container>
							              <ng-container *ngIf="task.vorgBearbeiter && task.vorgBearbeiter.length > 0">
                                  <span style="width: 148px">
                                    {{enumSvc.getFieldCaption('Vorgang', 'vorgBearbeiter')}}:
                                  </span>
								              <span class="typo-left">
                                    {{task.vorgBearbeiter}}
                                  </span>
								              <q></q>
							              </ng-container>
						              </div>
					              </div>
				              </div>
			              </ng-template>
		              </exg-data-list>
	              </div>
              </ng-template>
            </app-exg-tab-v2>
            <ng-container
              *ngIf="appSvc.isTableEmpty(taskTable) || appSvc.isTableLoading(TaskSummary.taskDetails)">
              <div *ngIf="appSvc.isTableEmpty(taskTable) && !(appSvc.isTableLoading(TaskSummary.taskDetails))"
                   class="splash empty">
                <p>Es wurde kein Datensatz ausgewählt</p>
              </div>
              <div *ngIf="appSvc.isTableLoading(taskTable) || appSvc.isTableLoading(TaskSummary.taskDetails)"
                   class="splash loading">
                <div class="spinner">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <div class="app-drawer">
      <ng-container *ngIf="excSecurity.isFeatured('TASKREAD')">
        <i (click)="toggleRightDrawer();"
           [class.fal]="!rightDrawerVisible"
           [class.fas]="rightDrawerVisible"
           [class.disabled]="appSvc.isTableLoading(taskTable) || appSvc.isTableEmpty(taskTable)"
           [tooltip]="getRessource('tooltip.openDetails')"
           flow="left"
           class="fa-info app-drawer-icon ">
        </i>
	      <i class="search-filter-seperator"></i>
	      <i *ngIf="excSecurity.isFeatured('CASEREAD')"
	         (click)="openCase()"
	         class="search-filter-action fal fa-folder"
	         [tooltip]="getRessource('tooltip.openCase')"
	         [class.disabled]="taskTable.isLoading || !taskTable.selectedRow"
	         flow="left"></i>
        <i class="search-filter-seperator" *ngIf="excSecurity.isFeatured('CASEREAD')"></i>
	      <i (click)="openWorkspaceV2()" class="search-filter-action fal fa-chevron-right"
	         [tooltip]="getRessource('openWorkspace')" flow="left"
	         [class.disabled]="taskTable.isLoading || !taskTable.selectedRow">
	      </i>
        <i class="search-filter-seperator"></i>
      </ng-container>
      <app-exg-dropdown position="underleft"
                        [adaptiveHeightActive]="true"
                        [adaptiveHeightOffset]="400"
                        [disabled]="taskTable.isLoading || !taskTable.selectedRow">
        <ng-template #hostTemplate>
          <i class="search-filter-action fal fa-plus" [tooltip]="'Hinzufügen'" flow="left"
             [class.disabled]="taskTable.isLoading || !taskTable.selectedRow"></i>
        </ng-template>
        <ng-template #contentTemplate let-popup>
          <div class="content" style="max-height: 500px">
            <div (click)="config.newReport(); popup.close();"
                 *ngIf="excSecurity.isFeatured('REPORTCREATE')"
                 class="md-menu-item">
              Bericht
            </div>
            <div (click)="config.newServiceRecord(); popup.close();"
                 *ngIf="excSecurity.isFeatured('DEVELOPMENT')"
                 class="md-menu-item">
              Leistungsaufstellung
            </div>
            <!-- Questionnaire Creation -->
            <ng-container *ngIf="TaskSummary && TaskSummary.questionnaireConfigurations && TaskSummary.questionnaireConfigurations.data
            && TaskSummary.questionnaireConfigurations.data.length > 0
            && excSecurity.isFeatured('RQUESTVCREATE')">
              <ng-container *ngIf="TaskSummary?.questionnaireConfigurations?.data?.length === 1; else multipleConfigElements">
                <ng-container *ngFor="let row of TaskSummary?.questionnaireConfigurations?.data">
                  <div (click)="createNewQuestionnaireVersion(row.qcnfID);popup.close();"
                       class="md-menu-item">Fragebogen {{row.qcfgName}}</div>
                </ng-container>
              </ng-container>
              <ng-template #multipleConfigElements>
                <app-exg-dropdown [adaptiveHeightActive]="true" >
                  <ng-template #hostTemplate>
                    <div class="md-menu-item"
                         *ngIf="excSecurity.isFeatured('RQUESTVCREATE')">
                      Fragebögen...
                    </div>
                  </ng-template>
                  <ng-template #contentTemplate let-popup>
                    <ng-container *ngFor="let row of TaskSummary?.questionnaireConfigurations?.data">
                      <div (click)="createNewQuestionnaireVersion(row.qcnfID);popup.close();"
                           class="md-menu-item typo-left">{{row.qcfgName}}</div>
                    </ng-container>
                  </ng-template>
                </app-exg-dropdown>
              </ng-template>
            </ng-container>
            <!-- Calculation Creation -->
            <ng-container *ngIf="TaskSummary && TaskSummary.calculationTemplates && TaskSummary.calculationTemplates.data
											            && TaskSummary.calculationTemplates.data.length > 0
											            && excSecurity.isFeatured('RCALCVCREATE')">
              <ng-container *ngIf="TaskSummary?.calculationTemplates?.data?.length === 1; else multipleTemplates">
                <ng-container *ngFor="let row of TaskSummary?.calculationTemplates?.data">
                  <div (click)="createNewCalculationVersion(row);popup.close();"
                       class="md-menu-item">Kalkulation {{row.ctName}}</div>
                </ng-container>
              </ng-container>
              <ng-template #multipleTemplates>
                <app-exg-dropdown  [adaptiveHeightActive]="true">
                  <ng-template #hostTemplate>
                    <div class="md-menu-item"
                         *ngIf="excSecurity.isFeatured('RCALCVCREATE')">
                      Kalkulation...
                    </div>
                  </ng-template>
                  <ng-template #contentTemplate let-popup>
                    <ng-container *ngFor="let row of TaskSummary?.calculationTemplates?.data">
                      <div (click)="createNewCalculationVersion(row);popup.close();"
                           class="md-menu-item typo-left">{{row.ctName}}</div>
                    </ng-container>
                  </ng-template>
                </app-exg-dropdown>
              </ng-template>
            </ng-container>
            <!-- Formular Creation -->
            <ng-container *ngIf="TaskSummary && TaskSummary.formularTemplates && TaskSummary.formularTemplates.data
											            && TaskSummary.formularTemplates.data.length > 0
											            && excSecurity.isFeatured('FORMVCREATE')">
              <ng-container *ngIf="TaskSummary?.formularTemplates?.data?.length === 1; else multipleTemplates">
                <ng-container *ngFor="let row of TaskSummary?.formularTemplates?.data">
                  <div (click)="createNewFormularVersion(row);popup.close();"
                       class="md-menu-item">Formular {{row.frmTName}}</div>
                </ng-container>
              </ng-container>
              <ng-template #multipleTemplates>
                <app-exg-dropdown  [adaptiveHeightActive]="true">
                  <ng-template #hostTemplate>
                    <div class="md-menu-item"
                         *ngIf="excSecurity.isFeatured('FORMVCREATE')">
                      Formularwesen (neu)
                    </div>
                  </ng-template>
                  <ng-template #contentTemplate let-popup>
                    <ng-container *ngFor="let row of TaskSummary?.formularTemplates?.data">
                      <div (click)="createNewFormularVersion(row);popup.close();"
                           class="md-menu-item typo-left">{{row.frmTName}}</div>
                    </ng-container>
                  </ng-template>
                </app-exg-dropdown>
              </ng-template>
            </ng-container>
            <ng-container *ngIf="excSecurity.isFeatured('MSGCREATE')">
              <div *ngIf="!(TaskSummary.defaultMessages.data.length > 0)" (click)="config.newMessage();popup.close();"
                   class="md-menu-item">Nachricht
              </div>
              <app-exg-dropdown *ngIf="TaskSummary.defaultMessages.data.length > 0" [adaptiveHeightActive]="true">
                <ng-template #hostTemplate>
                  <div class="md-menu-item">Nachricht...</div>
                </ng-template>
                <ng-template #contentTemplate let-popup>
                  <div (click)="config.newMessage();popup.close();" class="md-menu-item typo-left">Leere Nachricht</div>
                  <ng-container>
                    <ng-container *ngFor="let row of TaskSummary.defaultMessages.data">
                      <div (click)="config.newDefaultMessage(row.dmsgID);popup.close();"
                           class="md-menu-item typo-left">{{row.dmsgBezeichnung}}</div>
                    </ng-container>
                  </ng-container>
                </ng-template>
              </app-exg-dropdown>
            </ng-container>
            <div *ngIf="excSecurity.isFeatured('NTZEDIT')"
                 (click)="config.newNote();popup.close();" class="md-menu-item">
              Notiz
            </div>
            <div (click)="config.showUploadReceiptModal(); popup.close();"
                 *ngIf="excSecurity.isFeatured('RECEIPTCREATE')"
                 class="md-menu-item">
              <!-- 	         (excSecurity.isFeatured('DLUSR') && TaskSummary?.taskDetails?.data?.vorg_enmIdent_VorgangStatus <= 4) -->
              {{getGlobal('Receipt')}}
            </div>
	          <div (click)="config.showUploadStatementModal(); popup.close();"
	               *ngIf="excSecurity.isFeatured('STATEMENTCREATE')"
	               class="md-menu-item">
		          {{getGlobal('ReceiptStatement')}}
	          </div>
            <div (click)="config.showAttachmentUploadModal(); popup.close();"
                 *ngIf="excSecurity.isFeatured('DOCUMENTCREATE')"
                 class="md-menu-item">
              Anlage
            </div>
            <app-exg-dropdown *ngIf="TaskSummary.documentTemplate.data.length > 0"  [adaptiveHeightActive]="true">
              <ng-template #hostTemplate>
                <div class="md-menu-item"
                     *ngIf="excSecurity.isFeatured('TASKFORMCREATE')">
                  Formulare (alt)
                </div>
              </ng-template>
              <ng-template #contentTemplate let-popup>
                <ng-container *ngFor="let row of TaskSummary.documentTemplate.data">
                  <div (click)="config.documentTemplateDownload(row.dotID);popup.close();"
                       class="md-menu-item typo-left">{{row.dotName}}</div>
                </ng-container>
              </ng-template>
            </app-exg-dropdown>
            <div (click)="addVNData(); popup.close();"
                 *ngIf="excSecurity.isFeatured('CRMVNADD')
                && TaskSummary?.caseDetails?.data?.aue_oeID_VN
                && TaskSummary?.caseDetails?.data?.aue_oeID_VN !== '00000000-0000-0000-0000-000000000000'"
                 class="md-menu-item">
              Daten hinzufügen
            </div>
          </div>
        </ng-template>
      </app-exg-dropdown>
      <i class="search-filter-action fa-light fa-folders"
         *ngIf="excSecurity.isFeatured('DOCUMENTMGMT')"
         (click)="openFileOverview()"
         [class.disabled]="taskTable.isLoading || !taskTable.selectedRow"
         [tooltip]="'Dokumenten Manager'"
         flow="left"></i>
	    <i class="search-filter-action fa-light fa-screwdriver-wrench"
	       *ngIf="excSecurity.isFeatured('REPORTBUILDER')"
	       (click)="openReportBuilderOverlay()"
	       [class.disabled]="taskTable.isLoading || !taskTable.selectedRow"
	       [tooltip]="'Neuen Report erstellen'"
	       flow="left">
	    </i>
      <i class="search-filter-action fal fa-image" (click)="config.showAttachmentPreview()"
         [class.disabled]="taskTable.isLoading || !taskTable.selectedRow"
         [tooltip]="'Anlagen ansehen'"
         flow="left"></i>
      <i class="search-filter-seperator"></i>
      <i (click)="config.showHistory()" class="search-filter-action {{getResource('Tabs.History.Icon')}}"
         [class.disabled]="taskTable.isLoading || !taskTable.selectedRow"
         [tooltip]="'Historie'" flow="left"></i>
      <i class="search-filter-action fa-light fa-list-timeline"
         *ngIf="excSecurity.isFeatured('HISTORYEXTREAD')"
         (click)="OpenDetailHistoryModal()"
         [class.disabled]="taskTable.isLoading || !taskTable.selectedRow"
         [tooltip]="'History'"
         flow="left"></i>
      <i class="search-filter-seperator"></i>
      <ng-container *ngIf="VCrightTabControl.selectedtab === 3
                      && rightDrawerVisible
                      && !TaskSummary?.isLoading">
<!--         <i (click)="config.openCheckView()" -->
<!--            [tooltip]="getRessource('Receipt.openCheckview')" flow="left" -->
<!--            [class.disabled]="!config.receiptList.selectedRow && rightDrawerVisible" -->
<!--            class="search-filter-action fal fa-file-search"></i> -->
<!--         <i (click)="config.openCheckViewCollection();" -->
<!--            [tooltip]="getRessource('Receipt.openCheckviewCollection')" flow="left" -->
<!--            class="search-filter-action fal fa-brackets " -->
<!--            [class.disabled]="config.receiptList.state !== 0"> -->
<!--         </i> -->
        <app-exg-dropdown>
          <ng-template #hostTemplate>
            <i class="fal fa-file-chart-line search-filter-action"
               [class.disabled]="!(TaskSummary?.receiptList?.data
                                   && TaskSummary.receiptList.data.length > 0
                                   && !config.receiptList.isLoading)"
               [tooltip]="'Reports generieren'" flow="left">
            </i>
          </ng-template>
          <ng-template #contentTemplate>
            <div class="content">
<!--               <div class="md-menu-item" -->
<!--                    (click)="config.receiptTaskOpenTestReport()" -->
<!--                    [class.app-disabled]="!(TaskSummary?.receiptList?.data -->
<!--                                          && TaskSummary.receiptList.data.length > 0 -->
<!--                                          && !config.receiptList.isLoading)"> -->
<!--                 {{getRessource('ReportFileTT', { -->
<!--                 fileextension: 'xlsx', -->
<!--                 entity: 'Vorgang' -->
<!--               })}} -->
<!--               </div> -->
              <div class="md-menu-item"
                   (click)="config.receiptTaskOpenTestReportPdf()"
                   [class.app-disabled]="!(TaskSummary?.receiptList?.data
                                         && TaskSummary.receiptList.data.length > 0
                                         && !config.receiptList.isLoading)">
                {{getRessource('ReportFileTT', {
                fileextension: 'pdf',
                entity: 'Vorgang'
              })}}
              </div>
<!--               <div class="md-menu-item" -->
<!--                    (click)="config.receiptCaseOpenTestReport()" -->
<!--                    [class.app-disabled]="!(TaskSummary?.receiptList?.data -->
<!--                                          && TaskSummary.receiptList.data.length > 0 -->
<!--                                          && !config.receiptList.isLoading)"> -->
<!--                 {{getRessource('ReportFileTT', { -->
<!--                 fileextension: 'xlsx', -->
<!--                 entity: 'Auftrag' -->
<!--               })}} -->
<!--               </div> -->
              <div class="md-menu-item"
                   (click)="config.receiptCaseOpenTestReportPdf()"
                   [class.app-disabled]="!(TaskSummary?.receiptList?.data
                                         && TaskSummary.receiptList.data.length > 0
                                         && !config.receiptList.isLoading)">
                {{getRessource('ReportFileTT', {
                fileextension: 'pdf',
                entity: 'Auftrag'
              })}}
              </div>
            </div>
          </ng-template>
        </app-exg-dropdown>
        <i class="search-filter-seperator"></i>
      </ng-container>
    </div>
    <!-- Pager -->
    <exg-pager (PageChange)="taskTable.pageChanged($event)" *ngIf="!init"
               [pagingSource]="taskTable.paging"
               class="span-layout">
      <ng-template #leftTemplate>
        <app-exg-dropdown class="typo-small" [list]="preFilterDefinition" elementclass="typo-left" maxHeight="250px"
                          [label]="selectedMod.caption" position="abovecenter" listdisplay="caption"
                          (change)="changePreFilterMod($event.value)" >
        </app-exg-dropdown>
        <app-exg-dropdown class="typo-small" [list]="selectedMod.types" elementclass="typo-left" maxHeight="250px"
                          [label]="selectedType.caption" position="abovecenter" listdisplay="caption"
                          (change)="changePreFilterType($event.value)">
        </app-exg-dropdown>
      </ng-template>
      <ng-template #rightTemplate>
        <div class="app-pager-chips">
          <app-exg-filter-chips #VCFilterChips
                                [inputDataTable]="taskTable"
                                [VCFilterControl]="{ VCFilter: VCtaskTableFilterControl, VCSearch: VCtaskTableSearchControl, VCSort: VCtaskTableSortControl}">
          </app-exg-filter-chips>
        </div>
      </ng-template>
    </exg-pager>
  </div>
</div>


